<template>
  <div>
    <span class="copyright">
      © Copyright Fanomena {{ currentYear }}
    </span>
  </div>
</template>
<script>

export default {
  computed: {
    currentYear() {
      let currentDate = new Date
      return currentDate.getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Copyright.vue?fe046be0